import type { FaireProductEntity } from "../../entity_types/product";

export const p_f9nfendp46: FaireProductEntity = {
  token: "p_f9nfendp46",
  type: "product",
  name: "Mismatch Big Scarf",
  brandToken: "b_bganl3cn3b",
  brandName: "VERLOOP | knits",
  imageUrl:
    "https://cdn.faire.com/fastly/bc32368d3fe338da0cdb5f93b0df52b0cea9e095985c359b6faf4eceee1cd6ef.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/5a2a1a721f7271c337f63a96111170ef4fb6b55abaa7052bb08e78dd2f261ede.jpeg",
    "https://cdn.faire.com/fastly/f949317f5f634ae4b998926dd8dffe0067fe480fed09ac0711b4212d76cad8f2.jpeg",
    "https://cdn.faire.com/fastly/27b8fe61b4a95a21e29f0a2b32f44c49602a052c8954558eb163c40f560783f3.jpeg",
    "https://cdn.faire.com/fastly/1e3ddfc19437d982506c8ebb7523e4b9d23229c94e38a017f452cec6eeb30eb8.jpeg",
    "https://cdn.faire.com/fastly/dd1eb660efd4fa9d2af466e7f2bf781a68e1d43fddfa2c9b7aadb97185851912.jpeg",
    "https://cdn.faire.com/fastly/3abcce2e601ae713e9b7450ffe4d87d10797c4bde61dfd3145baeb67e44408d1.jpeg",
    "https://cdn.faire.com/fastly/68f45bb5d07b83cf24af6e67aa17a0d33e9badf5723704eb61192ed805173cff.jpeg",
    "https://cdn.faire.com/fastly/8f69a855acfef73d440f6bd874622d608f7d98e174fded686abad340c5053904.jpeg",
    "https://cdn.faire.com/fastly/d27b596188858c4cb87bc66bcf6a67027b3194d8a3a7b4e87823e9d162f7743a.jpeg",
  ],
  priceDollars: 35.5,
  description:
    'Oversized, soft jacquard knit scarf with modern, architectural colorblocking. Layer on the color with this big, comfy, cozy scarf all fall and winter long. Can be worn long or wrapped up like a cowl for extra warmth. Fully reversible. Made with hypoallergenic yarn.\n\nDetails \n100% Soft Acrylic\nMachine wash cold gentle cycle, dry flat\n12"W x 76"L\n\n',
  tags: [],
  msrpDollars: 78,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-05-06T17:55:49.360Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
